var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"shadow-root",rawName:"v-shadow-root"}],staticClass:"ux1-notifications-node"},[_c('div',{ref:"notifications"})])
}
var staticRenderFns = []

export { render, staticRenderFns }